import { Component } from '@angular/core';
import { BasePopUpComponent } from '../base-pop-up.component';

@Component({
    selector: 'app-loading-popup',
    templateUrl: './loading-popup.component.html',
    styleUrl: './loading-popup.component.scss',
})
export class LoadingPopupComponent extends BasePopUpComponent {}
